module.exports = __webpack_public_path__ + "static/img/ss08.9ea30ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/farkle-safari/ss08.png
// module id = J68b
// module chunks = 0